import Index from '@/pages/change-target-number/Index'
import List from '@/pages/change-target-number/List'

export default {
  path: 'change-numbers',
  component: Index,
  children: [
    {
      path: 'index',
      component: List
    }
  ]
}